import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { useClientId } from '../../../_hooks/useClientId';
import { PersonalInfoDTO } from './usePersonalInfoQuery';
import { TrustsDTO } from './useTrustsQuery';

export const FETCH_ESTATE_PLANNING_PERSONAL_INFO_ENDPOINT = '/Consumer/EstatePlanningPersonalInfo';

interface DeductionsAndGifts {
  AdministrationExpenseDeductionAmount: number;
  LifetimeGiftingExemptionUsedAmount: number;
}

export interface DeductionsAndGiftsDTO {
  PrincipalDeductionsAndGifts: DeductionsAndGifts;
  SpouseDeductionsAndGifts?: Partial<DeductionsAndGifts>;
}

export interface EstatePlanningDTO {
  DeductionsAndGifts: DeductionsAndGiftsDTO;
  SpouseTaxFilingState: number | null;
}

export interface EstatePlanningEstateOptions {
  LifetimeGiftingExemptionAmount: number;
  BaseLifetimeGiftingExemptionAmount: number;
}

export interface EstatePlanningOptionsDTO {
  StatesWithEstateTax: number[];

  PrimaryEstateOptions: EstatePlanningEstateOptions | null;

  SpouseEstateOptions?: EstatePlanningEstateOptions | null;

  AddUnusedExemption: boolean;
}

export interface EstatePlanningPersonalInfoDTO {
  PersonalInfo: PersonalInfoDTO;
  EstatePlanning: EstatePlanningDTO;
  EstatePlanningOptions: EstatePlanningOptionsDTO;
  Trusts: TrustsDTO;
}

interface FetchPersonalInfoParams {
  clientId: number;
}

export const fetchEstatePlanningPersonalInfo = async ({
  clientId,
}: FetchPersonalInfoParams): Promise<EstatePlanningPersonalInfoDTO> => {
  return authFetch(urlWithParams(FETCH_ESTATE_PLANNING_PERSONAL_INFO_ENDPOINT, { clientId }));
};

export const useEstatePlanningPersonalInfoQuery = ({ enabled = false }) => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.estatePlanningPersonalInfo(clientId),

    () => fetchEstatePlanningPersonalInfo({ clientId }),

    {
      cacheTime: 0,
      enabled,
    },
  );
};
